import React from "react";
import { AutocompleteInput, ReferenceInput, required, WithPermissions } from 'react-admin';
import { suggestionsContainerProps } from '../utils';

const AccountFieldForAdmin = ({className}) =>{
  return (
    <WithPermissions render={({ permissions }) => (
      permissions === 'ROLE_ADMIN' ?
        <ReferenceInput
          className={className}
          source="account"
          reference="accounts"
          filterToQuery={searchText => ({ name: searchText })}
          validate={required()}
        >
          <AutocompleteInput options={{suggestionsContainerProps}}
                             optionText={choice => `ID: ${choice.id.replace('/accounts/', '')} Name: ${choice.name}`}
                             allowEmpty/>
        </ReferenceInput> : null
    )}
    />
  )
};

export default AccountFieldForAdmin;
